<template>
  <div class="">
    <div class="bg-white">
      <CoverPage />

      <div class="lg:flex md:flex container">
        <div class="lg:w-1/4 md:w-2/5 w-full">
          <ProductFilter />
        </div>
        <div class="lg:w-3/4 md:w-3/4 w-full">
          <ProductCards />
        </div>
      </div>
      <div class="bge3ceff-opa rounded-t-5555 mt-12">
        <DownloadApp />
        <Footer />
      </div>
    </div>
  </div>
</template>
<script>
import ProductFilter from "./components/ProductFilter";
import ProductCards from "./components/ProductCards";
import CoverPage from "./components/CoverPage.vue";
import DownloadApp from "../../home/components/DownloadApp.vue";
import Footer from "../../Footer.vue";
import "../scss/index.scss";
export default {
  data() {
    return {
      // key: value,
    };
  },
  components: {
    ProductCards,
    ProductFilter,
    CoverPage,
    DownloadApp,
    Footer,
  },
  metaInfo: {
    title: "Caregiver Saathi - All online Course",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Our e-learning platform offers specialised courses on practices of caregiving and care management at home. Avail free & paid courses.",
      },
    ],
  },
};
</script>
